import { Link, useNavigate } from 'react-router-dom';
import { resolveMediaUrl } from '../../utils/api';
import SocialLinksRow from './SocialLinksRow';

export default function SalonBrowseCard({
  shop,
  t,
  hovered,
  onHover,
}) {
  const logo = shop.logo_url ? resolveMediaUrl(shop.logo_url) : null;
  const navigate = useNavigate();

  return (
    <article
      className="barber-card salon-browser-card"
      onMouseEnter={() => onHover(shop.id)}
      onMouseLeave={() => onHover(null)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        background: 'var(--bg-card)',
        borderRadius: '12px',
        border: '1px solid var(--border)',
        overflow: 'hidden',
        transition: 'all 0.25s ease',
        boxShadow: hovered ? 'var(--shadow-orange)' : 'none',
        transform: hovered ? 'translateY(-4px)' : 'none',
        cursor: 'pointer',
      }}
      onClick={() => navigate(`/branches?shop_id=${shop.id}`)}
    >
      <div
        className="salon-browser-card-photo-main"
        style={{
          width: '100%',
          height: '200px',
          background: logo
            ? `url(${logo}) center/cover`
            : 'linear-gradient(135deg, var(--bg-card) 0%, var(--bg-dark) 100%)',
        }}
      />

      <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1rem', flex: 1 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2
            style={{
              fontFamily: "'Oswald', sans-serif",
              fontSize: '1.5rem',
              fontWeight: 700,
              color: '#ffffff',
              margin: 0,
            }}
          >
            {shop.name}
          </h2>
          <span
            style={{
              padding: '0.25rem 0.5rem',
              borderRadius: '6px',
              background: '#1a1a1a',
              color: '#ffffff',
              fontSize: '0.88rem',
              fontWeight: 700,
              fontFamily: "'Roboto', sans-serif",
            }}
          >
            ★ {shop.rating != null ? Number(shop.rating).toFixed(1) : '—'}
          </span>
        </div>

        <p
          style={{
            fontFamily: "'Roboto', sans-serif",
            fontSize: '0.88rem',
            color: 'rgba(255, 255, 255, 0.88)',
            margin: 0,
            lineHeight: 1.4,
          }}
        >
          {shop.locations && shop.locations.length > 0 ? (
            <>
              <span aria-hidden>📍</span> {shop.locations[0]}
              {shop.locations.length > 1 ? ` +${shop.locations.length - 1} locations` : ''}
            </>
          ) : (
            'Premium hair and beauty services.'
          )}
        </p>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
          <span
            style={{
              padding: '0.25rem 0.75rem',
              borderRadius: '100px',
              border: '1px solid var(--orange)',
              color: '#ffffff',
              fontSize: '0.75rem',
              fontWeight: 700,
              fontFamily: "'Oswald', sans-serif",
              letterSpacing: '0.05em',
              textTransform: 'uppercase',
            }}
          >
            {shop.category}
          </span>
          {shop.has_premium && (
            <span
              style={{
                padding: '0.25rem 0.75rem',
                borderRadius: '100px',
                border: '1px solid #D4AF37',
                color: '#D4AF37',
                fontSize: '0.75rem',
                fontWeight: 700,
                fontFamily: "'Oswald', sans-serif",
                letterSpacing: '0.05em',
                textTransform: 'uppercase',
              }}
            >
              VIP
            </span>
          )}
        </div>

        <div style={{ marginTop: 'auto', paddingTop: '1rem' }}>
          <Link
            to={`/branches?shop_id=${shop.id}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              padding: '0.75rem 0',
              background: 'var(--orange)',
              color: '#ffffff',
              borderRadius: '6px',
              fontFamily: "'Oswald', sans-serif",
              fontSize: '0.88rem',
              fontWeight: 700,
              letterSpacing: '0.05em',
              textTransform: 'uppercase',
              textDecoration: 'none',
              transition: 'background 0.2s',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {t('shops.viewBranches')}
          </Link>
        </div>
      </div>
    </article>
  );
}
